import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  createStyles,
  makeStyles,
  Grid,
  IconButton,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Theme,
  Menu,
  Fade,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
  Button,
  Divider,
  SwipeableDrawer,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoAboutMenu from "./MoAboutMenu";
import MoActiveMenu from "./MoActiveMenu";
import MoLaborArtMenu from "./MoLaborArtMenu";
import MoArchiveMenu from "./MoArchiveMenu";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      flexGrow: 1,
      fontSize: 24,
      fontWeight: 700,
      // color: "#0F4C81",
      //   color: "#bc243c",
      color: "white",

      fontFamily: "GmarketSansBold",
    },
    menuTitle: {
      paddingLeft: 32,
      fontSize: 16,
    },
    menuContainer: {
      //   [theme.breakpoints.down(320)]: {
      //     padding: 0,
      //     width: 320,
      //   },
      //   [theme.breakpoints.down(376)]: {
      //     padding: 0,
      //     width: 375,
      //   },
      //   [theme.breakpoints.between(377, 415)]: {
      //     padding: 0,
      //     width: 414,
      //   },
    },
    popoverPaper: {
      width: "100%",
      //   height: "80%",
      maxHeight: "unset",
      left: "0% !important",
      right: "0% !important",
      top: "56px !important",
      maxWidth: "100% !important",
    },

    list: {
      width: 250,
    },
    fullList: {
      width: "auto",
    },

    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
    },
    moTitle: {
      fontSize: 16,
      fontWeight: 700,
    },
    moArchive: {
      paddingLeft: 16,
      fontSize: 16,
      fontWeight: 700,
      margin: "12px 0px !important",
    },
  })
);

type Anchor = "top" | "left" | "bottom" | "right";
function MoCompanyName() {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState<string | false>(false);
  const handleChange = (panel: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean
  ) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Grid xs={12} item container>
      <Grid xs={10} item container style={{ paddingLeft: 32 }}>
        <Grid xs={5} item container alignItems={"center"}>
          <Link to={"/"} style={{ display: "flex" }}>
            <Grid
              // xs={3}
              component={"img"}
              style={{ height: 32, marginRight: 16 }}
              src={"/images/main/logo1.png"}
            ></Grid>
            <Grid
              // xs={7}
              component={"img"}
              style={{ height: 32 }}
              // style={{ height: 56 }}
              src={"/images/main/logo.png"}
            ></Grid>{" "}
          </Link>
        </Grid>
      </Grid>
      <IconButton
        onClick={() => {
          setOpen(true);
        }}
      >
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        onOpen={() => {
          setOpen(true);
        }}
      >
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.moTitle}>
              노동인권문화제 소개
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MoAboutMenu setOpen={setOpen} setExpanded={setExpanded} />
            {/* <MoAboutMenu /> */}
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
          >
            <Typography className={classes.moTitle}>활동</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MoActiveMenu setOpen={setOpen} setExpanded={setExpanded} />
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
          >
            <Typography className={classes.moTitle}>노동 X 예술</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MoLaborArtMenu setOpen={setOpen} setExpanded={setExpanded} />
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          {/* <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
          > */}
          <Link
            to={`/archive`}
            onClick={() => {
              setOpen(false);
            }}
          >
            <Typography className={classes.moArchive}>아카이브</Typography>
          </Link>
          {/* </AccordionSummary> */}
          {/* <AccordionDetails> */}
          {/* <MoArchiveMenu setOpen={setOpen} setExpanded={setExpanded}/> */}
          {/* </AccordionDetails> */}
        </Accordion>
        {/* <List> */}
        {/* <ListItem button> */}
        {/* <ListItemIcon> */}
        {/* <InboxIcon /> */}
        {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
        {/* </ListItemIcon> */}
        {/* <ListItemText primary={"text"} /> */}
        {/* </ListItem> */}
        {/* <ListItem button> */}
        {/* <ListItemIcon> */}
        {/* <InboxIcon /> */}
        {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
        {/* </ListItemIcon> */}
        {/* <ListItemText primary={"메롱"} /> */}
        {/* </ListItem> */}
        {/* </List> */}
      </SwipeableDrawer>
    </Grid>
  );
}

export default MoCompanyName;
